import { Controller } from "@hotwired/stimulus"
import { DotLottie } from "@lottiefiles/dotlottie-web"

export default class extends Controller {
  static targets = ["player"]
  static values = {
    src: String,
    renderer: { type: String, default: "svg" },
  }

  connect() {
    // Check for reduced motion preference
    const isReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

    if (isReducedMotion) {
      console.log("Reduced motion detected, animations disabled.")
      return
    }

    // Lazy loading animations with IntersectionObserver
    this.initLazyLoading()
  }

  // Initialize IntersectionObserver for lazy loading
  initLazyLoading() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadLottie(entry.target)
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.1 }
    )

    this.playerTargets.forEach((canvas) => observer.observe(canvas))
  }

  // Load a Lottie animation on the specified canvas
  loadLottie(canvas) {
    const src = canvas.getAttribute("data-lottie-player-src-value")
    if (!src) return

    new DotLottie({
      canvas: canvas,
      src: src,
      loop: true,
      autoplay: true,
    })
  }

  // Show a hidden animation on demand
  showAnimation(event) {
    const targetId = event.currentTarget.getAttribute("aria-controls")
    const targetElement = this.playerTargets.find(
      (el) => el.id === targetId
    )

    if (targetElement) {
      this.loadLottie(targetElement)
    }
  }
}
